/* eslint-disable */


/**
 * Create styles for `<AccountsPage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<AccountsPage />` styles
 */
const accountsPageStyles = ({ theme }) => ({
  accountBillTo: {
    marginBottom: theme.spacing(1) * 2,
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.grey[700],
  },
  root: {},
});

export default accountsPageStyles;
